function isShippingInfoComplete (address) {

	return (
		address
		&& address.FirstName !== ''
		&& address.LastName !== ''
		&& address.AddressLine1 !== ''
		&& address.City !== ''
		&& address.Country !== ''
		&& ((address.PhoneNumber && address.PhoneNumber !== '') || (address.Phone && address.Phone !== ''))
		&& ([ 'US', 'CA' ].indexOf(address.Country) !== -1 ? address.PostalCode !== '' : true)
		// if we have a list of states for a country, then it's required even if address is international
		// this is equivalent to the rule we have in the jQuery form validation for State dropdown
		&& (window.lp.globals.regions[address.Country].States.length > 0 ? address.State !== '' : true)
	);

}

export default isShippingInfoComplete;
